import { actionCreator } from '@blink/components/src/utils';

import {
    FETCH_AGREEMENTS_FROM_CONTRACT,
    GET_AGREEMENTS,
    GET_CLIENT_POOL_BY_ID,
    GET_USER_WALLET_BALANCE,
    SET_AGREEMENTS_LOADING_FALSE,
    SET_LENDER_AGREEMENTS,
    SET_BORROWER_AGREEMENTS,
    SET_CLIENT_POOL_BY_ID,
    SET_NO_WALLET_INFO_FOR_AGREEMENTS,
    SET_POOL_BY_ID_LOADING_FALSE,
    SET_USER_BORROWS,
} from './constants';

import { Agreement, ClientPool, ROLE } from '@/shared/api/borrow';

export const getAgreementsAction = (payload: { role?: ROLE; withoutCache?: boolean }) =>
    actionCreator(GET_AGREEMENTS, payload);

export const getUserWalletBalanceAction = (payload: { role?: ROLE; withoutCache?: boolean }) =>
    actionCreator(GET_USER_WALLET_BALANCE, payload);

export const setUserBorrows = (payload: Agreement[]) => actionCreator(SET_USER_BORROWS, payload);

export const setAgreementsLoadingFalseAction = () => actionCreator(SET_AGREEMENTS_LOADING_FALSE);

export const setLenderAgreementsAction = (payload: Agreement[]) =>
    actionCreator(SET_LENDER_AGREEMENTS, payload);

export const setBorrowerAgreementsAction = (payload: Agreement[]) =>
    actionCreator(SET_BORROWER_AGREEMENTS, payload);

export const fetchAgreementsFromContractAction = () =>
    actionCreator(FETCH_AGREEMENTS_FROM_CONTRACT);

export const setNoWalletInfoForAgreementsAction = () =>
    actionCreator(SET_NO_WALLET_INFO_FOR_AGREEMENTS);

export const getClientPoolByIdAction = (payload: string) =>
    actionCreator(GET_CLIENT_POOL_BY_ID, payload);
export const setClientPoolByIdAction = (payload: ClientPool) =>
    actionCreator(SET_CLIENT_POOL_BY_ID, payload);
export const setClientPoolByIdActionFalseAction = () => actionCreator(SET_POOL_BY_ID_LOADING_FALSE);
